import React, { useState, useRef, useContext, useEffect } from "react";
import {
  Modal,
  Form,
  message,
  Button,
  Row,
  Col,
  Typography,
} from "antd";
import btnStyles from "../../../styles/Custom/Button.module.css";
import { getCookie } from "../../../helpers/localStorage";
import { FacilityID } from "../../../constants/defaultKeys";
import { UserContext } from "../../../context/UserContext";
import {
  patientInvestigationsOrderAPI,
  patientInvestigationsOrderUpdateAPI,
} from "../../../services/patient.services";
import dayjs from "dayjs";
import InitialInvestigationForm from "./InitialInvestigationForm";
import { CloseOutlined } from "@ant-design/icons";
import useIsMobile from "../../../hooks/useIsMobile";
import "../../../components/Receptionist/receptionistMobileForms.css";
import "./InvestigationModal.css";

const InvestigationsUploadModal = ({
  open,
  setOpen,
  refreshPage,
  editData,
  id,
}) => {
  const isMobile = useIsMobile();
  const { userDetails } = useContext(UserContext);
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const [uploadFile, setUploadFile] = useState([]);
  const [uploadFileLoading, setUploadFileLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editData?.id) {
      form.setFieldsValue({
        ...editData,
        date: dayjs(editData?.investigation_date),
      });
      setUploadFile(editData?.report_path);
    }
  }, [editData?.id]);

  const onFinish = (values) => {
    setLoading(true);
    const formData = {
      facility: Number(getCookie(FacilityID)) || userDetails?.currFacility,
      patient: Number(id),
      ip_admission: Number(id),
      name: values?.name,
      investigation_date: dayjs(values?.date).format("YYYY-MM-DD"),
      report_path: uploadFile,
      is_initial: true,
    };
    const apiCall = editData?.id
      ? patientInvestigationsOrderUpdateAPI(editData?.id, formData)
      : patientInvestigationsOrderAPI(formData);
    apiCall
      .then((res) => {
        message.success(res?.data?.message);
        setLoading(false);
        setOpen(false);
        refreshPage();
      })
      .catch((err) => {
        message.error(err?.response?.data?.message);
        setLoading(false);
      });
  };

  return (
    <Modal
      title={
        <Row>
          <Col span={20}>
            <Typography style={{ marginLeft: isMobile ? 0 : undefined }}>
              {editData?.id
                ? "Edit Initial Investigation"
                : "Add Initial Investigation"}
            </Typography>
          </Col>
          <Col span={4} className="flex-end">
            <CloseOutlined onClick={() => setOpen(false)} />
          </Col>
        </Row>
      }
      open={open}
      onCancel={() => setOpen(false)}
      afterClose={() => {
        form.resetFields();
        setUploadFile([]);
      }}
      destroyOnClose
      closeIcon={null}
      centered={false}
      width={isMobile ? "100%" : "40%"}
      style={isMobile ? undefined : { top: "8px" }}
      wrapClassName={
        isMobile
          ? "reception-modal-fullscreen investigation-modal-mobile-wrap"
          : undefined
      }
      classNames={
        isMobile
          ? { wrapper: "reception-modal-fullscreen investigation-modal-mobile-wrap" }
          : undefined
      }
      className={isMobile ? "investigation-modal-mobile" : undefined}
      styles={
        isMobile
          ? {
              wrapper: { padding: 0, overflow: "hidden" },
              content: {
                height: "100%",
                maxHeight: "100dvh",
                margin: 0,
                top: 0,
                padding: 0,
                borderRadius: 0,
              },
              header: {
                padding: "16px 20px 12px",
                marginBottom: 0,
              },
              body: {
                flex: 1,
                overflow: "auto",
                padding: "12px 20px 24px",
              },
              footer: {
                padding: "12px 20px calc(16px + env(safe-area-inset-bottom, 0px))",
                marginTop: 0,
              },
            }
          : undefined
      }
      footer={
        <div
          className="flex-end investigation-modal-footer"
          style={{ gap: isMobile ? 10 : 24 }}
        >
          <Button
            type="primary"
            ghost
            className={btnStyles.mdBtn}
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>
          <Button
            loading={loading}
            disabled={uploadFileLoading}
            htmlType="submit"
            type="primary"
            className={btnStyles.mdBtn}
            onClick={() => {
              if (formRef.current) {
                formRef.current.submit();
              }
            }}
          >
            Upload
          </Button>
        </div>
      }
    >
      <Form
        layout="vertical"
        form={form}
        ref={formRef}
        onFinish={onFinish}
        className="investigation-modal-form"
      >
        <InitialInvestigationForm
          setUploadFile={setUploadFile}
          setUploadFileLoading={setUploadFileLoading}
          editData={editData}
          uploadFile={uploadFile}
        />
      </Form>
    </Modal>
  );
};

export default InvestigationsUploadModal;
